import { BrowserRouter } from "react-router-dom";
import {
  StyledEngineProvider,
  THEME_ID as MUI_THEME_ID,
  ThemeProvider as MuiThemeProvider,
} from "@mui/material/styles";
import { MsalProvider } from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { QueryClientProvider } from "@tanstack/react-query";

import AppRoutesWrapper from "containers/app-routes-wrapper";
import Fonts from "components/partials/fonts/fonts";
import ToastContainer from "components/partials/toast/toast-container";
import { Stack } from "ui/stack";
import { DateLocalizationProvider } from "ui/date-picker";
import { useCleanPaste } from "hooks/use-clean-paste";

import { queryClient } from "config/query-client";

import apolloMuiTheme from "theme";

type AppProps = {
  publicClientApplication: IPublicClientApplication;
};

export const App = ({ publicClientApplication }: AppProps) => {
  useCleanPaste();

  return (
    <MsalProvider instance={publicClientApplication}>
      <QueryClientProvider client={queryClient}>
        <StyledEngineProvider injectFirst>
          <MuiThemeProvider theme={{ [MUI_THEME_ID]: apolloMuiTheme }}>
            <DateLocalizationProvider>
              <Stack spacing={0} sx={{ height: "100%" }} className="bg-gray-100">
                <Fonts />
                <BrowserRouter
                  future={{
                    v7_relativeSplatPath: true,
                    v7_startTransition: true,
                  }}>
                  <ToastContainer />
                  <AppRoutesWrapper />
                </BrowserRouter>
              </Stack>
            </DateLocalizationProvider>
          </MuiThemeProvider>
        </StyledEngineProvider>
      </QueryClientProvider>
    </MsalProvider>
  );
};
